import { is } from 'bpmn-js/lib/util/ModelUtil';
import VariableChangesEntry from './variableChangeEntry';

const LOW_PRIORITY = 500;

export default function VariableChangesProvider(
	propertiesPanel,
	translate
) {
	this.getGroups = function(element) {
		return function(groups) {

			if (is(element, 'bpmn:SequenceFlow')) {
				groups.push({
					id: 'variableChanges',
					label: translate('Variable Changes'),
					entries: VariableChangesEntry(element)
				});
			}

			return groups;
		};
	};

	propertiesPanel.registerProvider(LOW_PRIORITY, this);
}

VariableChangesProvider.$inject = [
	'propertiesPanel',
	'translate'
];